import {
  NotificationsOutlineIcon,
  SignoutOutlineIcon,
} from '@carboncopyco/icons';
import {
  Avatar,
  ColorHex,
  Dropdown,
  DropdownItem,
  Spacer,
  TextBase,
  TextButton,
  TooltipBubble,
} from '@carboncopyco/ui';
import { useAnalytics } from '@carboncopyco/utils';
import type { ReactNode } from 'react';
import { AnalyticsEvents } from '../../../../shared/constants/analytics.events';
import { useCustomNavigate } from '../../../hooks/useCustomNavigate';
import { useFlagsFallback } from '../../../hooks/useFlagsFallback';

interface UserMenuProps {
  triggerElement: ReactNode;
  organization: any;
  openOrganizationModal: (data: any) => void;
  onLogout: (data: any) => void;
  userEmail: string;
}
function UserMenu({
  organization,
  openOrganizationModal,
  onLogout,
  userEmail,
  triggerElement,
}: UserMenuProps) {
  const { trackEvent } = useAnalytics();
  const flags = useFlagsFallback();
  const { navigateToNotificationsSettings } = useCustomNavigate();

  return (
    <Dropdown triggerElement={triggerElement}>
      <TooltipBubble
        placement="top"
        title="Go to profile"
      >
        <DropdownItem>
          {organization && (
            <div className="hover:bg-ds-natural-50 rounded-md w-ds-info-section flex flex-col items-center cursor-pointer">
              <Spacer amount={0.75} />
              {organization && (
                <Avatar
                  initials={organization?.organization_name}
                  image={organization?.icon}
                />
              )}
              <Spacer />
              <TextButton
                label={organization?.organization_name || 'org_name'}
                color="text-ds-natural-600"
              />
              <Spacer amount={0.25} />
              <TextBase
                label={userEmail}
                color="text-ds-natural-300"
              />
              <Spacer amount={1.75} />
            </div>
          )}
        </DropdownItem>
      </TooltipBubble>
      <Spacer amount={0.75} />
      {/* <Separator horizontal /> */}
      <Spacer amount={0.75} />
      <DropdownItem
        label="Switch org"
        onClick={openOrganizationModal}
      />
      <Spacer amount={0.75} />
      {flags?.notificationsSettings && (
        <DropdownItem
          iconLeft={<NotificationsOutlineIcon size={20} />}
          label="Notifications"
          onClick={navigateToNotificationsSettings}
        />
      )}
      {/* <Separator horizontal /> */}
      <Spacer amount={0.75} />
      <DropdownItem
        onClick={(e) => {
          trackEvent(AnalyticsEvents.CLICK_LOGOUT, {
            location: 'login_page',
          });
          onLogout(e);
        }}
        iconRight={
          <SignoutOutlineIcon
            size={24}
            color={ColorHex.natural600}
          />
        }
        label="Logout"
      />
    </Dropdown>
  );
}

export default UserMenu;
